@use "../../styles/mixins";

.container {
    background-image: url("../../../static/img/bg-slate.png");
    background-position: top center;
    background-repeat: no-repeat;
    background-size: cover;
    color: var(--color-white);
    padding: 3.4375rem 0 7.1875rem;
}

.tabList {
    align-items: center;
    display: flex;
    gap: 5.6vw;
    justify-content: center;
    margin: 3.75rem 0 1.875rem;

    &[data-orientation="vertical"] {
        flex-direction: column;
    }
}

.tab {
    @include mixins.chalk-lines;

    background-color: transparent;
    border: none;
    color: var(--color-white);
    cursor: pointer;
    font-family: Chalk, monospace;
    font-size: 2rem;
    padding: 0;
    text-transform: uppercase;
}
